<template>
    <v-footer
        class="tables-footer"
        color="white"
        height="80px"
        fixed
        inset
        app
    >
        <v-bottom-navigation
            v-model="bottomNav"
            background-color="transparent"
            height="80px"
            grow
        >
            <v-btn
                id="shift-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="shift"
                :disabled="disableFooter || !allows('allow_shifts') || !curCashRegister"
                @click="showShift"
            >
                <span class="item-text">
                    {{ $t('general.shift') }}
                </span>
                <v-icon class="mb-1">fal fa-calendar-check</v-icon>
            </v-btn>

            <v-btn
                v-if="locale === 'sr' && !noncashOnly && device.platform !== 'web'"
                id="sdc-management-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="sdcManagement"
                :disabled="disableFooter"
                @click="showSdcManagement"
            >
                <span class="item-text">
                    {{ $t('general.sdc_short') }}
                </span>
                <v-icon class="mb-1">fal fa-chart-network</v-icon>
            </v-btn>

            <v-btn
                v-if="curCashRegister && !curCashRegister.shared"
                id="cash-register-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="cashRegister"
                :disabled="disableFooter || !allows('allow_cash_register')"
                @click="showCashRegister"
            >
                <span class="item-text">
                    {{ $t('general.cash_register') }}
                </span>
                <v-icon class="mb-1">fal fa-cash-register</v-icon>
            </v-btn>

            <v-btn
                id="reports-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="reports"
                :disabled="disableFooter || !allows('allow_cash_register')"
                @click="showReports"
            >
                <span class="item-text">
                    {{ $tc('general.report', 2) }}
                </span>
                <v-icon class="mb-1">fal fa-file-chart-line</v-icon>
            </v-btn>

            <v-btn
                id="staff-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="staff"
                :disabled="disableFooter || !curShift"
                @click="showStaff"
            >
                <span class="item-text">
                    {{ $tc('general.waiter', 2) }}
                </span>
                <v-icon class="mb-1">fal fa-users</v-icon>
            </v-btn>

            <v-btn
                id="receipts-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="receipts"
                :disabled="disableFooter || !allows('allow_receipts')"
                @click="show.receipts = true"
            >
                <template v-if="!einvoiceOnly">
                    <span class="item-text">{{ $tc('general.receipt', 2) }}</span>
                    <v-icon class="mb-1">fal fa-receipt</v-icon>
                </template>
                <template v-else>
                    <span class="item-text">{{ $tc('general.einvoice', 2) }}</span>
                    <v-icon class="mb-1">fal fa-file-alt</v-icon>
                </template>
            </v-btn>

            <!-- <v-btn class="bottom-nav-item" color="teal" text value="options" @click="showBottomSheet = true">
                <span>{{ $t('general.options') }}</span>
                <v-icon>fal fa-ellipsis-h</v-icon>
            </v-btn> -->

            <v-btn
                id="logout-btn"
                class="bottom-nav-item"
                color="teal"
                text
                value="logout"
                @click="logout"
            >
                <span class="item-text">
                    {{ $t('general.log_out') }}
                </span>
                <v-icon class="mb-1">fal fa-sign-out</v-icon>
            </v-btn>
        </v-bottom-navigation>

        <v-bottom-sheet v-model="showBottomSheet">
            <div class="options">
                <v-list>
                    <v-subheader>{{ $t('general.options') }}</v-subheader>

                    <v-list-item
                        key="1"
                        class="bottom-sheet-item"
                        @click=""
                    >
                        <v-list-item-avatar
                            class="mr-3"
                        >
                            <v-avatar size="32px" tile>
                                <v-icon>fal fa-exchange</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-title>{{ $t('tables.transfer') }}</v-list-item-title>
                    </v-list-item>
                </v-list>

                <v-list>
                    <v-subheader>{{ $t('general.other_options') }}</v-subheader>

                    <v-list-item
                        key="1"
                        class="bottom-sheet-item"
                        @click=""
                    >
                        <v-list-item-avatar
                            class="mr-3"
                        >
                            <v-avatar size="32px" tile>
                                <v-icon>fal fa-people-carry</v-icon>
                            </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-title>{{ $t('tables.hand_over_table') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </div>
        </v-bottom-sheet>

        <v-btn
            elevation="2"
            fab
            large
            dark
            color="#ff9800"
            :absolute="true"
            :right="true"
            :disabled="disableFooter || !allows('allow_fast_order') || !curShift"
            style="top: -90px"
            @click="fastOrder()"
        >
            <v-icon>fal fa-fast-forward</v-icon>
        </v-btn>

        <!-- Shift Management -->
        <v-dialog
            v-model="show.shift"
            width="400"
            @keydown.esc="show.shift = false"
        >
            <div class="py-3 px-4 bg-white">
                <v-btn
                    class="h60 mb-3"
                    color="success"
                    block
                    large
                    :disabled="disableFooter || !!curShift || busy"
                    @click="openShift"
                >
                    {{ $t('general.open_shift') }}
                </v-btn>

                <v-btn
                    class="h60 mb-3"
                    color="error"
                    block
                    large
                    :disabled="disableFooter || !curShift || busy"
                    @click="initCloseShift()"
                >
                    {{ $t('general.close_shift') }}
                </v-btn>

                <v-btn
                    class="h60"
                    color="default"
                    block
                    large
                    @click="show.shift = false"
                >
                    {{ $t('general.cancel') }}
                </v-btn>
            </div>
        </v-dialog>

        <!-- SDC Management -->
        <sdc-management
            v-if="locale === 'sr' && !this.noncashOnly && device.platform !== 'web'"
            :show.sync="show.sdcManagement"
        />

        <!-- Cash Register Management -->
        <cash-register-management
            :show.sync="show.cashRegister"
            :disabled="busy"
            @deposit="show.cashRegisterDeposit = true"
            @cash-out="show.cashRegisterCashOut = true"
        />

        <!-- Terminal Register -->
        <terminal-register
            :show.sync="show.terminal"
        />

        <!-- Cash Register Management -->
        <reports-dialog :show.sync="show.reports" />

        <!-- Staff Management Component -->
        <staff
            :show.sync="show.staff"
            @update-deposit="showUserDeposit($event)"
        />

        <!-- Receipts -->
        <receipts :show.sync="show.receipts" />

        <!-- Deposit Dialog -->
        <numpad-expanded
            :show.sync="show.deposit"
            type="userDeposit"
            :title="$t('general.deposit')"
            :value="0"
            :total="depositUser ? depositUser.getDeposit().toRoundedUnit(2) : 0"
            @confirm="updateUserDeposit($event.value)"
        />

        <!-- Cash Register Initial Deposit Dialog -->
        <numpad-expanded
            :show.sync="show.cashRegisterDeposit"
            type="cashRegisterDeposit"
            :title="$t('general.cash_register_add_deposit')"
            :value="0"
            :total="0"
            @confirm="addCashRegisterDeposit($event.value)"
        />

        <!-- Cash Register Cash Out Dialog -->
        <numpad-expanded
            :show.sync="show.cashRegisterCashOut"
            type="cashRegisterCashOut"
            :title="$t('general.cash_register_cash_out')"
            :value="10"
            :total="show.cashRegisterCashOut ? curCashRegisterCash : 0"
            :max="show.cashRegisterCashOut ? curCashRegisterCash : 0"
            @confirm="addCashRegisterTransaction(-1 * $event.value)"
        />

    </v-footer>
</template>

<script>
import UserService from '@/services/UserService';
import EinvoiceService from '@/services/EinvoiceService';
import TerminalService from '@/services/TerminalService';

import User from '@/models/User';
import Shift from '@/models/Shift';
import CashRegister from '@/models/CashRegister';
import Terminal from '@/models/Terminal';

import Staff from '@/views/shared/components/Staff';
import SdcManagement from '@/views/shared/components/SdcManagement';
import CashRegisterManagement from '@/views/shared/components/CashRegisterManagement';
import TerminalRegister from '@/views/shared/components/TerminalRegister';
import ReportsDialog from '@/views/shared/components/ReportsDialog';
import Receipts from '@/views/shared/components/Receipts';
import NumpadExpanded from '@/components/NumpadExpanded';
import { mapGetters } from 'vuex';
import * as mutationTypes from '@/store/mutationTypes';

export default {
    name: 'TablesFooter',

    components: {
        Staff,
        CashRegisterManagement,
        TerminalRegister,
        SdcManagement,
        NumpadExpanded,
        Receipts,
        ReportsDialog
    },

    created() {
        this.eventBus.$on('cash-register-deposit', this.showCashRegisterDeposit);
    },

    async mounted() {
        // activated
        if (this.$route.params.show) {
            this.show[this.$route.params.show] = true;
        }

        const terminal = await Terminal.current()

        if(!terminal) {
            this.show.terminal = true;
        } else if(this.curShift && moment.duration(moment().diff(moment(this.curShift.opened_at))).asHours() > 72) {
            this.$confirm(
                this.$t('order.error.shift_too_long_description'),
                {
                    buttonTrueText: this.$t('general.close_shift'),
                    buttonCancelText: null,
                    icon: null,
                    color: 'error',
                    title: this.$t('order.error.shift_too_long'),
                    persistent: true,
                },
                async result => {
                    const closeShiftSuccess = await this.closeShift(true);
                    if(closeShiftSuccess) {
                        await this.openShift();
                    }
                }
            );
        }
    },

    beforeDestroy() {
        this.eventBus.$off('cash-register-deposit', this.showCashRegisterDeposit);
    },

    data: () => ({
        busy: false,

        bottomNav: '',

        show: {
            shift: false,
            sdcManagement: false,
            staff: false,
            receipts: false,
            cashRegister: false,
            terminal: false,
            reports: false,
            cashRegisterDeposit: false,
            cashRegisterCashOut: false,
            deposit: false,
        },

        depositUser: null,
        showBottomSheet: false
    }),

    watch: {
        $route(to, from) {
            if (to.params.show) {
                this.show[to.params.show] = true;
            } else {
                this.show.shift = this.show.staff = false;
            }
        },

        curShift(val) {
            this.show.shift = this.show.staff = false;
        },

        // show: {
        //     deep: true,
        //     handler(val) {
        //         let routeParam = null;
        //         Object.keys(val).forEach(item => {
        //             if (val[item]) {
        //                 routeParam = item;
        //             }
        //         });

        //         if (routeParam) {
        //             this.$router.push({ name: 'tables', params: { show: routeParam } }).catch(err => {});
        //         } else {
        //             this.$router.replace({ name: 'tables' });
        //         }
        //     }
        // },
    },

    computed: {
        ...mapGetters(['tableMode']),

        curShift() {
            return Shift.current();
        },

        curCashRegister() {
            return CashRegister.current();
        },

        curCashRegisterCash() {
            return this.curCashRegister ? this.curCashRegister.getCash().toRoundedUnit(2) : 0;
        },

        disableFooter() {
            return !!this.tableMode || !this.curCashRegister;
        },

        noncashOnly() {
            return this.tenant && this.tenant.venue && !!this.tenant.venue.settings.noncash_only
        },

        einvoiceOnly() {
            return EinvoiceService.einvoiceOnly();
        }
    },

    methods: {
        showCashRegisterDeposit() {
            this.show.cashRegisterDeposit = true
        },

        showShift() {
            this.show.shift = this.allows('allow_shifts') && !this.show.shift;
        },

        showSdcManagement() {
            this.show.sdcManagement = !this.show.sdcManagement
        },

        showCashRegister() {
            this.show.cashRegister = this.allows('allow_cash_register') && !this.show.cashRegister
        },

        showReports() {
            this.show.reports = this.allows('allow_cash_register') && !this.show.reports;
        },

        showStaff() {
            this.show.staff = !this.show.staff;
        },

        async openShift() {
            this.busy = true

            const result = await Shift.open()

            this.busy = false

            if(!result.success) {
                this.$snackbar(result.error, 'error');
                return false;
            }

            if(this.curCashRegister.depositRequired()) {
                this.show.shift = false;
                this.show.cashRegisterDeposit = true;
            } else {
                this.$snackbar(this.$t('general.shift_opened'), 'success');
            }

            return true;
        },

        async initCloseShift() {
            if(!this.canCloseShift()) {
                this.$snackbar(this.$t('tables.close_shift_error'), 'error');
                return;
            }

            this.show.shift = false;

            this.$confirm(
                this.$t('reports.shift_report_print_confirm'),
                {
                    buttonTrueText: this.$t('general.yes'),
                    buttonFalseText: this.$t('general.no'),
                    icon: 'fal fa-times',
                    color: 'info',
                    title: this.$t('reports.shift_report'),
                    persistent: true,
                },
                async result => {
                    if(result === null) return;

                    const curShiftOpenedAt = Shift.current().getOpenedAt().format('YYYY-MM-DD HH:mm:ss')
                    const shiftCloseResult = await this.closeShift();

                    if(result && shiftCloseResult) {
                        await this.printShiftReport(curShiftOpenedAt);
                    }
                }
            );
        },

        canCloseShift() {
            const usersDebtNotCleared = User.all().some(user => !user.getDebt().isZero());
            if (usersDebtNotCleared) return false;

            return true;
        },

        async closeShift(force = false) {
            this.busy = true

            const result = await Shift.close();

            this.busy = false

            if(!result.success) {
                this.$snackbar(result.error, 'error');
                return false;
            }

            if(!force) {
                this.$snackbar(this.$t('general.shift_closed'));
            }

            this.$store.commit(mutationTypes.SET_TABLE_PERMISSIONS, { tablePermissions: {} });

            return true;
        },

        async printShiftReport(startTime) {
            const curCashRegister = CashRegister.current();

            const report = await Report.create({
                type: 'shift_report',
                startTime: startTime,
                endTime: `${moment().format('YYYY-MM-DD HH:mm:ss')}`,
                cashRegisterId: curCashRegister.id,
                filterOrders: {
                    cashRegisterId: curCashRegister.id,
                }
            });

            const receiptPrinter = this.$printService.getAssignedPrinter('receipt');
            const useReceiptPrinter = !!receiptPrinter && this.device.platform !== 'web';
            const text = useReceiptPrinter ? report.getPrintable().toText(receiptPrinter.charsPerLine).join('\n') : null;

            this.$printService.printCustom(text, report.getPrintable().toHtml('report').join(''), null, { choosePrinter: !useReceiptPrinter })
        },

        showUserDeposit(user) {
            this.depositUser = user
            this.show.deposit = true
        },

        async updateUserDeposit(value) {
            this.busy = true;

            const result = await this.depositUser.addDeposit(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('staff.user_deposit_add_error'), 'error');
                return;
            }

            this.$snackbar(this.$t('staff.user_deposit_added'), 'success');
            this.show.deposit = false;
        },

        async addCashRegisterDeposit(value) {
            if(!this.curShift || value < 0 || (locale !== 'me' && value == 0)) {
                return
            }

            this.busy = true;

            const result = await this.curCashRegister.addTransaction(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('general.cash_register_add_deposit_error'), 'error');
                return;
            }

            this.show.cashRegisterDeposit = false;
            this.$snackbar(this.$t('general.cash_register_add_deposit_success'), 'success');
        },

        async addCashRegisterTransaction(value) {
            if(!this.curShift || value == 0) {
                return
            }

            if(this.curCashRegister.depositRequired()) {
                this.show.shift = false;
                this.show.cashRegisterDeposit = true;
                return;
            }

            this.busy = true;

            const result = await this.curCashRegister.addTransaction(value);

            this.busy = false;

            if(!result.success) {
                this.$snackbar(this.$t('general.cash_out_error'), 'error');
                return;
            }

            this.show.cashRegisterCashOut = false;
            this.$snackbar(this.$t('general.cash_out_success'), 'success');
        },

        fastOrder() {
            if(this.curCashRegister.depositRequired()) {
                this.show.cashRegisterDeposit = true;
                return
            }

            this.$router.push('order').catch(err => {})
        },

        logout() {
            UserService.logout();
            this.$router.push({ name: 'userLogin' }).catch(err => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.tables-footer {
    padding: 0px;

    .bottom-nav-item {
        max-width: 100% !important;
        min-width: 50px;

        &:not(.v-btn--active) {
            color: #333333 !important;
        }

        .item-text {
            @media (max-width: 762px) {
                white-space: break-spaces;
                max-width: 75px;
                height: 25px;
                display: flex;
                align-items: center;
            }

            @media screen and (max-width: 500px) {
                line-height: 1 !important;
                font-size: 10.5px;
            }

            @media screen and (max-width: 400px) {
                display: none;
            }
        }
    }
}

.options {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    background: white;

    .v-list {
        min-width: 200px;

        .bottom-sheet-item {
            height: 55px;
            padding: 0 0 0 10px;

            .icon-disabled {
                opacity: 0.5;
            }
        }
    }
}
</style>
